// Функция сброса состояния пазла
export function resetPuzzleStateInternal() {
  return {
    resetTime: Date.now(),
    isInitialized: false,
    isLoading: false,
    puzzleImage: null,
    file_id: null,
    imageDimensions: { width: 0, height: 0 },
    boardDimensions: { width: 0, height: 0 },
    pieceBaseDimensions: { width: 0, height: 0 },
    rows: 0,
    cols: 0,
    pieces: {},
    placedPiecesCount: 0,
    draggingPiece: null,
    trayScrollLeft: 0,
    trayScrollTop: 0,
    svgDefs: null,
    bgUrl: null,
    dimensionsCalculated: null,
    puzzleImageElement: null, // <--- Сбрасываем элемент при ресете
  };
} 